import { PlanType, FoodType, SubscriptionFrequency, Currency, Country } from '@calo/types';
import { PricingService } from '.';
import { CALO_FOOD_TYPE_PRICING, CALO_BH_FOOD_TYPE_MAGIC_PRICING, CALO_PLAN_RAMADAN_DISCOUNT } from './constants';
class CaloPlanService {
    constructor(magicPrice) {
        if (magicPrice && magicPrice === true) {
            this.magicPrice = magicPrice;
            this.caloFoodTypePrice = CALO_BH_FOOD_TYPE_MAGIC_PRICING;
        }
        else {
            this.caloFoodTypePrice = CALO_FOOD_TYPE_PRICING;
        }
    }
    getFoodTypeForPlan(planType, country) {
        if (country && country === Country.KW) {
            switch (planType) {
                case PlanType.skipDinner:
                    return [FoodType.breakfast, FoodType.lunch, FoodType.snack, FoodType.snack];
                case PlanType.skipBreakfast:
                    return [FoodType.dinner, FoodType.lunch, FoodType.snack, FoodType.snack];
                case PlanType.businessLunch:
                    return [FoodType.lunch, FoodType.snack, FoodType.snack];
                case PlanType.ramadan:
                    return [FoodType.lunch, FoodType.dinner, FoodType.snack, FoodType.snack, FoodType.snack];
                case PlanType.futoor:
                    return [FoodType.lunch, FoodType.snack, FoodType.snack, FoodType.snack];
                case PlanType.dessert:
                    return [FoodType.dessert];
                default:
                    return [FoodType.breakfast, FoodType.dinner, FoodType.lunch, FoodType.snack, FoodType.snack];
            }
        }
        switch (planType) {
            case PlanType.skipDinner:
                return [FoodType.breakfast, FoodType.lunch, FoodType.snack];
            case PlanType.skipBreakfast:
                return [FoodType.dinner, FoodType.lunch, FoodType.snack];
            case PlanType.businessLunch:
                return [FoodType.lunch, FoodType.snack];
            case PlanType.ramadan:
                return [FoodType.lunch, FoodType.dinner, FoodType.snack, FoodType.snack, FoodType.snack];
            case PlanType.futoor:
                return [FoodType.lunch, FoodType.snack, FoodType.snack, FoodType.snack];
            case PlanType.dessert:
                return [FoodType.dessert];
            default:
                return [FoodType.breakfast, FoodType.dinner, FoodType.lunch, FoodType.snack];
        }
    }
    getFoodTypePrice(foodType, dietType, currency) {
        const fta = (Array.isArray(foodType) ? foodType : [foodType]).reduce((res, ft) => {
            if (!res[ft]) {
                res[ft] = 0;
            }
            res[ft]++;
            return res;
        }, {});
        const breakfastPrice = (fta[FoodType.breakfast] || 0) * this.caloFoodTypePrice[dietType][FoodType.breakfast][currency];
        const lunchAndDinnerPrice = ((fta[FoodType.dinner] || 0) + (fta[FoodType.lunch] || 0)) * this.caloFoodTypePrice[dietType][FoodType.dinner][currency];
        const snackPrice = (fta[FoodType.snack] || 0) * this.caloFoodTypePrice[dietType][FoodType.snack][currency];
        const dessertPrice = (fta[FoodType.dessert] || 0) * this.caloFoodTypePrice[dietType][FoodType.dessert][currency];
        const coffeePrice = (fta[FoodType.coffee] || 0) * this.caloFoodTypePrice[dietType][FoodType.coffee][currency];
        const juicePrice = (fta[FoodType.juice] || 0) * this.caloFoodTypePrice[dietType][FoodType.juice][currency];
        return breakfastPrice + lunchAndDinnerPrice + snackPrice + dessertPrice + coffeePrice + juicePrice;
    }
    getPlan({ planType, foodType, extras = [], dietType, frequency, currency }) {
        var _a, _b;
        let pricePerDay = this.getFoodTypePrice([...foodType, ...extras], dietType, currency);
        if (planType === PlanType.ramadan || planType === PlanType.futoor) {
            pricePerDay -= ((_b = (_a = CALO_PLAN_RAMADAN_DISCOUNT === null || CALO_PLAN_RAMADAN_DISCOUNT === void 0 ? void 0 : CALO_PLAN_RAMADAN_DISCOUNT[currency]) === null || _a === void 0 ? void 0 : _a[dietType]) === null || _b === void 0 ? void 0 : _b[planType]) || 0;
        }
        if (planType === PlanType.businessLunch) {
            switch (currency) {
                case Currency.SAR:
                    pricePerDay += 2;
                    break;
            }
        }
        if (!this.magicPrice) {
            pricePerDay -= (frequency === SubscriptionFrequency.monthly && planType === PlanType.full && currency === Currency.BHD) ? 1 : 0;
        }
        if (![PlanType.ramadan, PlanType.futoor, PlanType.custom, PlanType.dessert].includes(planType)
            && currency === Currency.KWD
            && foodType.filter(foodType => foodType === FoodType.snack).length >= 2) {
            pricePerDay -= CALO_FOOD_TYPE_PRICING[dietType][FoodType.snack][Currency.KWD];
        }
        if (frequency === SubscriptionFrequency.weekly) {
            switch (currency) {
                case Currency.BHD:
                    pricePerDay += 1;
                    break;
                case Currency.SAR:
                    pricePerDay += 10;
                    break;
                case Currency.AED:
                    pricePerDay += 10;
                    break;
                case Currency.KWD:
                    pricePerDay += 1;
                    break;
                case Currency.OMR:
                    pricePerDay += 1;
                    break;
                default:
                    pricePerDay += 1;
            }
        }
        return {
            id: planType,
            frequency,
            extras,
            foodType,
            pricePerDay,
            dietType
        };
    }
    getPlanPrice(plan, deliveryDays, currency = Currency.BHD) {
        const price = (plan.frequency === SubscriptionFrequency.weekly ? 1 : 4) * deliveryDays.length * plan.pricePerDay;
        return PricingService.roundAmount(price, currency);
    }
}
export default CaloPlanService;
